import React, {useEffect, useState} from "react"
import {
	KeyValueCard,
	KeyValueCardContainer,
	KeyValueCardKey,
	KeyValueCardValue,
} from "../../components/KeyValueCard/KeyValueCard"
import {startCase} from "lodash"
import {OrgName} from "../../components/OrgName/OrgName"
import {BankName} from "../../components/BankName/BankName"
import {UnitOrBankUserOnly} from "../../containers/PermissionedUser/PermissionedUser"
import {UnitUserOnly} from "../../containers/PermissionedUser/PermissionedUser"
import {isDepositOrBatchOrFBOAccount} from "../../resources/account"
import moment from "moment"
import {Card, getPanAlias} from "../../resources/card"
import {DepositAccount} from "../../resources/account"
import {hasPermission} from "../../services/permission"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {useAccessToken} from "../../services/auth"
import {useRefreshToken} from "../../hooks/useRefreshToken"

export default function CardInfo({card, account}: {card: Card; account?: DepositAccount}) {
	const accessToken = useAccessToken()
	const [refreshToken] = useRefreshToken()
	const [panAlias, setPanAlias] = useState<string | undefined>(undefined)
	const canViewPanAlias = hasPermission("card.PANAlias", "get")

	const [panAliasState, fetchPanAlias] = useAsyncResultIdle(
		() => getPanAlias(accessToken, card.id),
		[refreshToken, card.id]
	)

	useEffect(() => {
		if (!canViewPanAlias) return
		fetchPanAlias()
	}, [refreshToken, card.id, canViewPanAlias])

	useEffect(() => {
		panAliasState.match(
			() => null,
			() => null,
			(panAlias) => setPanAlias(panAlias.data.attributes.pan),
			() => null
		)
	}, [panAliasState])

	const left = (
		<KeyValueCard singleColumn={true} transparent={true} className="card-info-key-value-card">
			<KeyValueCardContainer>
				<KeyValueCardKey>ID</KeyValueCardKey>
				<KeyValueCardValue>{card.id}</KeyValueCardValue>

				{account && isDepositOrBatchOrFBOAccount(account) && (
					<>
						<UnitOrBankUserOnly>
							<KeyValueCardKey>Org</KeyValueCardKey>
							<KeyValueCardValue>
								<OrgName orgId={account.relationships?.org?.data?.id?.toString()} element={"span"} width={100} />
							</KeyValueCardValue>
						</UnitOrBankUserOnly>
						<UnitUserOnly>
							<KeyValueCardKey>Bank</KeyValueCardKey>
							<KeyValueCardValue>
								<BankName bankId={account.relationships?.bank?.data?.id?.toString()} width={100} />
							</KeyValueCardValue>
						</UnitUserOnly>
					</>
				)}

				<KeyValueCardKey>Created At</KeyValueCardKey>
				<KeyValueCardValue>{moment(card.attributes.createdAt).format("MM/DD/YYYY")}</KeyValueCardValue>
			</KeyValueCardContainer>
		</KeyValueCard>
	)

	const right = (
		<KeyValueCard singleColumn={true} transparent={true} className="card-info-key-value-card">
			<KeyValueCardContainer>
				{canViewPanAlias && (
					<>
						<KeyValueCardKey>Pan Alias</KeyValueCardKey>
						<KeyValueCardValue className="card-info-container-pan-alias">{panAlias}</KeyValueCardValue>
					</>
				)}
				<KeyValueCardKey>Type</KeyValueCardKey>
				<KeyValueCardValue>{startCase(card.type.replace("Card", ""))}</KeyValueCardValue>

				<KeyValueCardKey>Updated At</KeyValueCardKey>
				<KeyValueCardValue>
					{card.attributes.updatedAt ? moment(card.attributes.updatedAt).format("MM/DD/YYYY") : "--"}
				</KeyValueCardValue>

				<KeyValueCardKey>Exp</KeyValueCardKey>
				<KeyValueCardValue>
					{card.attributes.expirationDate ? moment(card.attributes.expirationDate).format("MM/YYYY") : "--"}
				</KeyValueCardValue>
			</KeyValueCardContainer>
		</KeyValueCard>
	)
	return (
		<div className="card-info-container">
			<div>{left}</div>
			<div>{right}</div>
		</div>
	)
}
